import Nakajitsu from './nakajitsu'

export default Nakajitsu
